import React, { useMemo } from "react";
import "./Rolling.css";
import Pagination from "./Pagination";
import { useSelector } from "react-redux";
import DataTable from "../../../components/common/DataTable/DataTable";
import StatusCell from "../../../components/common/TableCells/StatusCell";
import DateCell from "../../../components/common/TableCells/DateCell";

function RollingTable({
  dataItem,
  userData,
  setCurrentPage,
  currentPage,
  pagesData,
  getRollingReserveData,
}) {
  const role = useSelector((store) => store.userReducer.role);
  let token = useSelector((store) => store.userReducer.token);

  const columns = [];

  if (role === "super" || role === "operation" || role === "subSuper") {
    columns.push({
      key: "businessName",
      header: "Business Name",
      wrapCell: true,
      render: (row) => row.businessName,
    });
  }

  columns.push(
    {
      key: "orderId",
      header: "Order Id",
      wrapCell: true,
      render: (row) => row.orderId || "-",
    },
    {
      key: "transactionId",
      header: "Transaction Id",
      wrapCell: true,
      render: (row) => row.transactionId || "-",
    },
    {
      key: "amount",
      header: "Amount (₹)",
      render: (row) => Number(row.amount || 0).toFixed(2),
    },
    {
      key: "updatedAt",
      header: "Updated Date",
      render: (row) => <DateCell date={row.createdAt} />,
    },
    {
      key: "days",
      header: "Days Left",
      render: (row) => (row.days < 0 ? 0 : row.days),
    },
    {
      key: "status",
      header: "Status",
      render: (row) => (
        <StatusCell status={row.status ? "COMPLETED" : "PENDING"} />
      ),
    },
  );

  const formattedData = useMemo(() => {
    return (dataItem || []).map((item) => ({
      ...item,
      businessName:
        userData?.find((user) => user.id === item.userId)?.alias ||
        userData?.find((user) => user.id === item.userId)?.id ||
        "N/A",
    }));
  }, [dataItem, userData]);

  return (
    <div className="table-main-report">
      <DataTable
        columns={columns}
        data={formattedData}
        emptyMessage="No Rolling Reserve Data Found"
      />

      {dataItem?.length > 0 && (
        <div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pagesData={pagesData}
            getRollingReserveData={getRollingReserveData}
            token={token}
          />
        </div>
      )}
    </div>
  );
}

export default RollingTable;
